import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaSearch, FaUser, FaBars } from 'react-icons/fa';
import styled from 'styled-components';

const NavContainer = styled.div`
  display: none; /* Hidden by default */

  @media (max-width: 768px) { /* Show only on mobile (adjust breakpoint as needed) */
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    background: white;
    padding: 10px 0;
    box-shadow: 0 -2px 5px rgba(0,0,0,0.1);
    z-index: 1000;
  }
`;

const NavLink = styled(Link)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #555;
  text-decoration: none;
  font-size: 12px;
  
  svg {
    font-size: 20px;
    margin-bottom: 4px;
  }

  &:hover, &:active {
    color: #007bff; /* Add your preferred active/hover color */
  }
`;

const MobileBottomNav = () => {
  return (
    <NavContainer>
      <NavLink to="/">
        <FaHome />
        <span>Home</span>
      </NavLink>
        <NavLink to="/MyOrders">
        <FaBars />
        <span>MyOrders</span>
      </NavLink>
     
      <NavLink to="/profile">
        <FaUser />
        <span>Profile</span>
      </NavLink>
    </NavContainer>
  );
};

export default MobileBottomNav;